module.exports = __webpack_public_path__ + "static/everday-lentil-lunch.0e77ffa6.jpg";